import React from "react";

import { useTranslation } from "react-i18next";

import { CaretLeftIcon } from "@phosphor-icons/react";

import { Button } from "@local-logic/design-system";

import { useRootElement } from "../../context";

import * as styles from "./styles";

export function CloseButton() {
  const { t } = useTranslation("localContent");
  const { onSelectScore } = useRootElement();

  return (
    <Button
      data-testid="sidebar-header-back-button"
      variant="ghost"
      prefixIcon={<CaretLeftIcon weight="bold" className={styles.icon} />}
      className={styles.container}
      onClick={onSelectScore ? onSelectScore(null) : undefined}
    >
      {t("sidebar.header.backAction")}
    </Button>
  );
}
